module.exports = __webpack_public_path__ + "img/ML_Headshot.d5e71ec5.jpeg";